/**
 * Created by lilei on 2018/3/28.
 */
export {default as theme} from './theme'


// WEBPACK FOOTER //
// ./src/components/Style/theme/index.js